import { Dialog, Transition } from '@headlessui/react'
import React, { Fragment, ReactNode } from 'react'
import { dialogPanel, cancelButton, confirmButton } from './styles'
import { ButtonAction } from 'pages/NotifyEvent/styles'

interface ConfirmProps {
    isOpen: boolean
    labelButtomConfirm: string
    labelButtomClose: string
    handleConfirmModal: () => void
    handleCloseModal: () => void
    children?: ReactNode
}

const Confirm: React.FC<ConfirmProps> = ({
    isOpen,
    handleConfirmModal,
    handleCloseModal, 
    labelButtomConfirm,
    labelButtomClose,
    children
}) => {
    
    return (
        <div data-testid={'modal-warning'}>
            <Transition appear show={isOpen} as={Fragment}>
                <Dialog
                    as="div"
                    className="relative z-30"
                    onClose={handleCloseModal}
                >
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in dur   ation-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black bg-opacity-25" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4 text-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel className={dialogPanel}>
                                    <div className='flex flex-col'>
                                        {children}
                                        <div className='justify-center flex gap-6'>
                                        <ButtonAction
                                                onClick={handleConfirmModal}
                                                className={confirmButton}>
                                                {labelButtomClose}
                                            </ButtonAction>
                                            <ButtonAction  
                                                    onClick={handleCloseModal} 
                                                    className={cancelButton}>
                                                {labelButtomConfirm}
                                            </ButtonAction>
                                        </div>
                                        
                                    </div>                                    
                            
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </div>
    )
}

export { Confirm }
